import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Table } from 'reactstrap';
import { Image, H5, P, H6 } from '../../AbstractElements';
import { DailyDropdown, MonthlyData, RecentSalesTitle, ThisMonthBooking } from '../../Constant';
import DropdownCommon from '../../CommonElements/DropDown';
import { url } from '../../Constant';


const RecentSales = () => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [viewAll, setViewAll] = useState(false);

  useEffect(() => {
    // Replace with your API endpoint
    fetch(`${url}/api/admin/dashboard/monthly-bookings`,
      {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        setCompanies(data);
        setLoading(false);
        // console.log(data)
      })
      .catch(error => {
        setError(error);
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;
  return (
    <Col xxl='4' md='6' className='appointment-sec box-col-6'>
      <div className='appointment'>
        <Card>
          <CardHeader className='card-no-border'>
            <div className='header-top'>
              <H5 attrH5={{ className: 'm-0' }}>{ThisMonthBooking}</H5>
              {/* <div className='card-header-right-icon'>
                <DropdownCommon icon={false} options={DailyDropdown} btn={{ caret: true }} />
              </div> */}
            </div>
          </CardHeader>
          <CardBody className='pt-0' style={{ maxHeight: '250px', overflowY: 'auto' }}>
            <div className='appointment-table'>
              <Table borderless responsive>
                <tbody>
                  {companies && companies.length > 0 && companies?.slice(0, viewAll ? companies?.length : 3)?.map((item, i) => (
                    <tr key={i}>
                      {/* <td>
                        <Image attrImage={{ className: 'img-fluid img-40 rounded-circle', src: require(`../../../assets/images/dashboard/user/${item.image}`), alt: 'user' }} />
                      </td> */}
                      <td className='img-content-box' style={{ width: "40%" }}>
                        <H6 className='d-block f-w-500'>
                          {item?.bookingInfo?.customer?.slice(0, 11)}{ item?.bookingInfo?.customer?.length > 11 && "..."}
                        </H6>
                        <span className='f-light' style={{ fontSize: "0.8rem" }}>{item?.createdAt}</span>
                      </td>
                      <td className='text-end'>
                        <P>{item?.machineInfo?.machineModel?.slice(0, 11)}{ item?.machineInfo?.machineModel?.length > 11 && "..."}</P>
                      </td>
                      <td className='text-end'>
                        <P>{item?.bookingInfo?.siteLocation?.slice(0, 11)}{item?.bookingInfo?.siteLocation?.length>11 && "..."}</P>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </CardBody>
          {companies && companies?.length > 3 &&
            <div onClick={() => setViewAll(!viewAll)} className='d-flex justify-content-center mt-1'
              style={{
                cursor: "pointer",
                color: "darkblue",
                fontSize: "0.7rem",
                textDecoration: "underline"
              }}>
              <p>{viewAll ? "View Less" : "View All"}</p>
            </div>
            }
        </Card>
      </div>
    </Col>
  );
};

export default RecentSales;
